<template>
  <div>
    <device-detail-dialog :alarmInfoList="alarmInfoList" :deviceInfo="deviceInfo" :dialogVisible="dialogVisible"
                          :width="width"
                          @dialogClose="close"></device-detail-dialog>
    <!--内景图烟感,漏水,噪声,红外检测-->
    <device-detail-box :boxVisible.sync="boxVisible" :deviceInfo="deviceInfo" @boxClose="close"
                       v-show="boxVisible"></device-detail-box>
    <!--设备一览烟感,漏水,噪声,红外检测,温湿度-->
    <device-box-dialog :alarmInfoList="alarmInfoList" :deviceInfo="deviceInfo" :dialogVisible="boxDialogVisible"
                       :width="width"
                       @dialogClose="close"></device-box-dialog>
    <!--温湿度设备详情-->
    <device-detail-div :deviceInfo="deviceInfo" :divVisible="divVisible"
                       @divClose="close" v-if="divVisible"></device-detail-div>
    <!--消防主机-->
    <fireAlarmControlPanel :deviceInfo="deviceInfo" :divVisible="FACPVisible"
                           @divClose="close" v-if="FACPVisible"></fireAlarmControlPanel>
  </div>
</template>

<script>
import DeviceDetailDialog from "@/components/device_details/comp/DeviceDetailDialog";
import DeviceDetailBox from "@/components/device_details/comp/DeviceDetailBox";
import DeviceDetailDiv from "@/components/device_details/comp/DeviceDetailDiv";
import {getDeviceInfo} from "@/network/device-info";
import {getListByDeviceId} from "@/network/alarm-realtime";
import DeviceBoxDialog from "@/components/device_details/comp/DeviceBoxDialog";
import fireAlarmControlPanel from "@/components/device_details/comp/fireAlarmControlPanel";

export default {
  name: "DeviceDetail",
  components: {
    DeviceDetailDialog,
    DeviceDetailBox,
    DeviceDetailDiv,
    DeviceBoxDialog,
    fireAlarmControlPanel
  },
  props: {
    distributionStyle: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dialogVisible: false,
      boxDialogVisible: false,
      boxVisible: false,
      divVisible: false,
      // 消防主机是否显示
      FACPVisible: false,
      deviceInfo: {},
      alarmInfoList: [],
      width: '60%',
    }
  },
  methods: {
    //显示设备详情
    showDeviceDetails(deviceId) {
      this.alarmInfoList = [];
      this.boxVisible = false;
      this.divVisible = false;
      getDeviceInfo(deviceId).then(res => {
        if (res.code === 0) {
          if (res.data.detailUrl == null) {
            res.data.detailUrl = "dialog:AllPointTable";
            // return
          }
          if (res.data.detailUrl === "newPage") {
            const properties = JSON.parse(res.data.portProperties)
            if (properties) {
              window.open('http://' + properties.IP + ':' + properties.PORT, '_blank')
            }
            return;
          }
          const name = res.data.detailUrl.split(":");
          this.deviceInfo = res.data
          this.width = '60%'
          //内景图设备详情
          if (this.distributionStyle) {
            if (name[0] === "div") {
              this.divVisible = true;
            } else if (name[0] === "box") {
              this.boxVisible = true;
              res.data.detailUrl = name[1];
            } else if (name[0] === "map") {
              this.FACPVisible = true;
            } else {
              res.data.detailUrl = name[1];
              this.getAlarmData(deviceId);
              if (name[0] === "dialog") {
                this.dialogVisible = true;
                if (name[1] === "DVR") {
                  this.width = '60%'
                }
                if (name[1] === "AIRSW") {
                  this.width = '70%'
                }
              } else {
                //网络设备 dialogBox
                this.width = '60%'
                this.boxDialogVisible = true;
              }
            }
          } else { //设备一览设备详情
            res.data.detailUrl = name[1];
            this.getAlarmData(deviceId);
            if (name[0] !== "dialog") {
              if (name[0] === "dialogBox") {
                this.width = '60%'
                this.boxDialogVisible = true;
              } else if (name[0] === "map") {
                this.FACPVisible = true;
              } else {
                this.width = '50%'
                this.boxDialogVisible = true;
              }
            } else {
              if (name[1] === "DVR") {
                this.width = '60%'
              }
              if (name[1] === "AIRSW") {
                this.width = '70%'
              }
              this.dialogVisible = true;
            }
          }

        }
      })
    },
    getAlarmData(deviceId) {
      getListByDeviceId(deviceId).then(res => {
        if (res.code === 0) {
          this.alarmInfoList = res.data;
        }
      })
    },
    //设备详情关闭
    close(visible) {
      this.dialogVisible = visible;
      this.boxDialogVisible = visible;
      this.boxVisible = visible;
      this.divVisible = visible;
      this.FACPVisible = visible;
    },
  }
}
</script>

<style scoped>

</style>
